import styled from 'styled-components'
import variables from '../../styles/variables'
export const ImgAdmin = styled.img`
    width: 70px;
`
export const ContainerAdmin = styled.div`
    background-color: whitesmoke;
    p{
        font-size: 3rem;
        color: ${variables.background};
        text-align: center;
        margin: 0;
    }
    h3{
        text-align: center;
    }
`   